import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FroalaEditorModule } from 'angular-froala-wysiwyg';
import { FroalaEditorComponent } from './components/froala-editor/froala-editor.component';

@NgModule({
  imports: [MatFormFieldModule, MatInputModule, CommonModule, ReactiveFormsModule, FroalaEditorModule.forRoot()],
  providers: [],
  declarations: [FroalaEditorComponent],
  exports: [FroalaEditorComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class FroalaModule {}
